import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { useAuthStore } from '@/shared/auth/stores/authStore'

// LEGACY URL — kept only as a redirect so any in-flight bookmarks /
// shared links continue to work. The canonical route is now
// /issues/{issueId}; all live callers (IssueRow, IssuesTab,
// SiteIssuesTab, HOD inbox in S6) navigate there directly.
const searchSchema = z.object({
  issueId: z.string().optional(),
})

export const Route = createFileRoute('/entities/$id_/particular-issue')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    if (search.issueId) {
      throw redirect({ to: '/issues/$issueId', params: { issueId: search.issueId } })
    }
    // Stale link without an issueId — bounce to entities list.
    throw redirect({ to: '/entities' })
  },
  component: () => null,
})
